export const shouldBeExpandedByDefault = (
  expand: boolean,
  copyElementIndex: number
) => {
  return expand ? copyElementIndex : undefined;
};
